import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';
import {OrganizationService} from '../../services/organization.service';
import {InstituationService} from '../../services/instituation';
import {
  AddressAutocompleteComponent
} from '../../../../ui-components/address-autocomplete/address-autocomplete.component';
import {AppMessageService} from '../../../../shared/services/app-message/app-message.service';
import {IAddress} from '../../../../ui-components/address-autocomplete/models/address';
import {ParameterService} from '../../../../shared/services/parameter/parameter.service';
import {merge, Subject, takeUntil} from 'rxjs';
import {VehicleService} from '../../../definition/vehicle/services/vehicle.service';
import {Option} from '../../../../ui-components/core-dropdown/core-dropdown.component';

interface IDropdownItem {
  label: string;
  value: number;
}

@Component({
  selector: 'app-create-organization-tab-one',
  templateUrl: './create-organization-tab-one.component.html',
  styleUrl: './create-organization-tab-one.component.scss',
})
export class CreateOrganizationTabOneComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Output() createOrg = new EventEmitter<any>(); // tab 1 de ki form değerlerini ana componenet e iletmek için kullanıldı.
  @Output() updateOrg = new EventEmitter<any>();
  @ViewChild('addressComponent') addressComponent: AddressAutocompleteComponent;

  clickedOrg: any = null;
  days = [1, 2, 3, 4, 5, 6, 7];
  initialValues = {
    name: '',
    organizationType: null,
    startDate: new Date(),
    endDate: new Date(),
    startTime: null,
    durationHours: 1,
    durationMinutes: 0,
    ambulanceCount: null,
    amount: null,
    doctorStatus: false,
    description: '',
    protocolNo: null,
    vehicleNo: '',
    cancelled: false,
    cancelDescription: '',
    address: null,
    instituation: null,
    authorizedPerson: '',
    authorizedPhone: '',
    status: null,
    frequency: null,
    recurringDate: null,
    isRecurring: false,
    plannedVehicles: [],
  };

  initialRepeatOrgValues = {
    endDate: null,
    recurrenceFrequency: false,
    day: null,
  };

  orgId: number | null;
  addedDayCount: number = 0; // eğer bitiş tarihine organizasyon süresinden dolayı gün eklenmişse güncellemek için ve tekrarlı organizasyonda bitiş tarihine 1 gün eklemek için tutuluyor

  recurrings: { startDate: Date | null; endDate: Date | null }[] = [];
  minDateLimit: Date | null = null;
  private readonly destroy$ = new Subject<void>();
  createForm: FormGroup;
  isCancelled: boolean = false;
  editable: boolean = false;

  orgTypes: IDropdownItem[] = [];
  instutuationTypes: IDropdownItem[] = [];

  openDialogVehicles = false;
  vehicles: Option[] = [];
  selectedVehicles: any[] = [];
  first = 0;
  rows = 20;
  organizationData: any;
  showVehicleDialog: boolean = false;
  searchTerm: string = '';
  filteredVehicles: any[] = [];
  loadingVehicles: boolean = false;
  plannedVehiclesList: {
    id?: number;
    vehicle: { licensePlate: string; id: number };
    protocolNo112: string | null;
  }[] = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly insService: InstituationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly orgService: OrganizationService,
    private readonly appMessageService: AppMessageService,
    private readonly parameterService: ParameterService,
    private readonly vehicleService: VehicleService
  ) {
    this.minDateLimit = new Date();
    this.minDateLimit?.setHours(0, 0, 0);
    this.createForm = this.fb.group({
      name: ['', Validators.required],
      organizationType: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      startTime: [null, Validators.required],
      durationHours: [1, Validators.required],
      durationMinutes: [0, Validators.required],
      ambulanceCount: null,
      amount: null,
      doctorStatus: [false],
      description: [''],
      protocolNo: null,
      vehicleNo: [{value: '', disabled: true}],
      cancelled: [false],
      cancelDescription: [''],
      address: [null, Validators.required],
      instituation: [null, Validators.required],
      authorizedPerson: '',
      authorizedPhone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      status: new FormControl({disabled: true}),
      frequency: null,
      recurringDate: null,
      isRecurring: false,
      plannedVehicles: new FormControl([]),
    });
  }

  ngAfterViewInit(): void {
    merge(
      this.createForm.get('startDate')!.valueChanges,
      this.createForm.get('startTime')!.valueChanges,
      this.createForm.get('durationHours')!.valueChanges,
      this.createForm.get('durationMinutes')!.valueChanges
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.calculateEndTime();
      });

    this.createForm
      .get('isRecurring')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.isCheckboxChange();
      });

    merge(
      this.createForm.get('recurringDate')!.valueChanges,
      this.createForm.get('frequency')!.valueChanges
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.recurringChange();
      });
  }

  async initialize(data?: any) {
    this.recurrings = [];
    if (data) {
      this.organizationData = data;
      this.orgId = data.id;
      this.clickedOrg = data;
      this.editable = true;
      const duration = data?.duration?.split(':') ?? ['1', '0'];
      this.createForm.patchValue({
        ...data,
        organizationType: data?.organizationType?.id || data?.organizationType,
        instituation: data?.instituation?.id,
        startDate: data?.startDate ? new Date(data?.startDate) : null,
        startTime: data?.startDate ? new Date(data?.startDate) : null,
        endDate: data?.endDate ? new Date(data?.endDate) : null,
        status: data?.status,
        durationHours: Number(duration[0]) || 1,
        durationMinutes: Number(duration[1]) || 0,
        plannedVehicles: data?.organizationPlannedVehicles?.map((v: any) => v.vehicle?.id) ?? []
      });

      if (this.addressComponent && data.address) {
        this.createForm.patchValue({
          address: {
            city: data.address?.city,
            formattedAddress: data?.address?.formattedAddress,
            street: data?.address?.street,
            district: data?.address?.district,
            postalCode: data?.address?.postalCode,
            addressDescription: data?.address?.addressDescription,
            latitude: data?.address?.latitude,
            longitude: data?.address?.longitude,
          },
        });
      }

      this.plannedVehiclesList = this.organizationData?.organizationPlannedVehicles?.map(
        (e: any) => {
          console.log(e);
          return {
            id: e.id,
            vehicle: {
              id: e.vehicle?.id,
              licensePlate: e.vehicle?.licensePlate,
            },
            protocolNo112: e?.protocolNo112,
          };
        }
      ) ?? [];
    } else {
      this.orgId = null;
      this.editable = false;
      this.createForm.patchValue({...this.initialValues});
      this.addressComponent.addressForm.reset();
    }
  }

  resetFormValues() {
    this.plannedVehiclesList = [];
    this.createForm.reset(this.initialValues);
    this.recurrings = [];
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.parameterService
      .getParameterValues('data-group', 'organizationTypes')
      .subscribe((response) => {
        this.orgTypes = response.datas.values.map((data: any) => {
          return {label: data.valueObject.name.value, value: data.id};
        });
      });

    this.insService.getList().subscribe((res) => {
      this.instutuationTypes = res.map((item: any) => ({
        label: item.title,
        value: item.id,
      }));
    });

    this.vehicleService.getVehicleList().subscribe({
      next: (res: any) => {
        this.vehicles = res.map((v: any) => {
          return {
            label: v?.licensePlate + (v?.dot ? ' - ' + v?.dot?.dotName : ''),
            value: v?.id,
            disabled: !v?.isActive,
          };
        });
      },
      error: (err) => {
        console.error(err);
      },
    });

    this.createForm
      .get('plannedVehicles')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((selectedVehicles: unknown) => {
      const vehicleIds = this.normalizePlannedVehicleIds(selectedVehicles);

      // eski listeyi filtrele → seçilenler dışındakileri çıkar
      this.plannedVehiclesList =
        this.plannedVehiclesList?.filter((item) =>
          vehicleIds.includes(item.vehicle.id)
        ) ?? [];

      // yeni seçilenleri ekle (listede yoksa)
      for (const v of vehicleIds) {
        const vehicle = this.vehicles.find((car) => car.value === v);
        const exists = this.plannedVehiclesList.some(
          (item) => item.vehicle.id === v
        );
        if (!exists) {
          this.plannedVehiclesList.push({
            vehicle: {
              id: vehicle?.value,
              licensePlate: vehicle?.label ?? '',
            },
            protocolNo112: null,
          });
        }
      }

    });

    const statusControl = this.createForm.get('cancelled');

    if (statusControl) {
      statusControl.valueChanges.subscribe((checked: boolean) => {
        this.isCancelled = checked;
        const cancelDescriptionControl =
          this.createForm.get('cancelDescription');
        if (cancelDescriptionControl) {
          if (checked) {
            cancelDescriptionControl.patchValue('');
            cancelDescriptionControl.setValidators([Validators.required]);
          } else {
            cancelDescriptionControl.clearValidators();
            cancelDescriptionControl.patchValue('');
          }
          cancelDescriptionControl.updateValueAndValidity();
        }
      });
    }

    this.createForm.get('status')?.disable();
  }

  // address seçildiğinde adresin değerlerini formdali address objesine set etmek için
  handleSetAddress(address: IAddress) {
    if (this.createForm) {
      this.createForm.patchValue({address});
    }
  }

  // validation  for
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  openAddressModal() {
    this.addressComponent.openDialog(this.createForm?.value.address);
  }

  resetValues() {
    this.addedDayCount = 0;
    this.plannedVehiclesList = [];
    this.createForm.reset(this.initialValues);
    this.orgId = null;
    this.addressComponent.closeDialog();
  }

  private normalizePlannedVehicleIds(value: unknown): number[] {
    if (value == null) {
      return [];
    }
    if (Array.isArray(value)) {
      return value.filter((id) => id != null);
    }
    return [value as number];
  }

  calculateEndTime() {
    const startDate = this.createForm.controls['startDate']?.value
      ? new Date(this.createForm.controls['startDate']?.value)
      : null;
    const startTime = this.createForm.controls['startTime']?.value
      ? new Date(this.createForm.controls['startTime']?.value)
      : null;
    const durationHours =
      this.createForm.controls['durationHours']?.value ?? null;
    const durationMinutes =
      this.createForm.controls['durationMinutes']?.value ?? null;
    const isRecurring = this.createForm.controls['isRecurring']?.value;
    //randevu tarihi ve saati seçildiğinde  hesaplamaya başla
    if (startDate && startTime) {
      const date = new Date(startDate);
      const time = new Date(startTime);

      date.setHours(time.getHours());
      date.setMinutes(time.getMinutes());
      date.setSeconds(0);
      date.setMilliseconds(0);
      const endDateTime = new Date(
        date.getTime() + (durationHours * 60 + durationMinutes) * 60000
      ); //milisaniyeye çevirdik;

      this.createForm.patchValue(
        {
          startDate: date,
          endDate: endDateTime,
        },
        {emitEvent: false}
      );
      if (isRecurring) {
        this.recurringChange();
      }
    }
  }

  recurringChange() {
    const startDate = this.createForm.controls['startDate']?.value ?? null;
    const recurringDate =
      this.createForm.controls['recurringDate']?.value ?? null;
    const frequency = this.createForm.controls['frequency']?.value ?? null;

    const durationHours =
      this.createForm.controls['durationHours']?.value ?? null;
    const durationMinutes =
      this.createForm.controls['durationMinutes']?.value ?? null;
    if (!startDate || !recurringDate || !frequency) {
      this.recurrings = [];
      return;
    }

    const start = new Date(startDate);
    const end = new Date(recurringDate);

    end.setHours(start.getHours());
    end.setMinutes(start.getMinutes());
    end.setSeconds(0);
    end.setMilliseconds(0);

    const recurrings = [];
    let current = new Date(start);

    while (current <= end) {
      recurrings.push({
        startDate: new Date(current),
        endDate: new Date(
          new Date(current).getTime() +
          (durationHours * 60 + durationMinutes) * 60000
        ),
      });
      // Şimdi frequency kadar günü ileri al
      current.setDate(current.getDate() + frequency);
    }
    this.recurrings = recurrings;
  }

  isCheckboxChange() {
    this.recurrings = [];
    const isRecurring = this.createForm.controls['isRecurring']?.value ?? null;

    if (!isRecurring) {
      this.createForm.patchValue({
        frequency: null,
        recurringDate: null,
      });
      this.recurrings = [];
    }
  }

  create() {
    if (this.createForm.valid) {
      this.orgService
        .create({
          ...this.createForm.value,
          startDate: new Date(this.createForm.value.startDate),
          endDate: new Date(this.createForm.value.endDate),
          amount: Number(this.createForm.value.amount),
          protocolNo: Number(this.createForm.value.protocolNo),
          ambulanceCount: Number(this.createForm.value.ambulanceCount),
          cancelDescription: '',
        })
        .subscribe((res) => {
          this.appMessageService.successToast(
            'Successful!',
            'successful!',
            20000,
            'top-right'
          );
          this.createOrg.emit(res);
        });
    }
  }

  update() {
    if (this.createForm.valid) {
      this.orgService
        .update({
          id: this.orgId,
          ...this.createForm.value,
          startDate: new Date(this.createForm.value.startDate),
          endDate: new Date(this.createForm.value.endDate),
          amount: Number(this.createForm.value.amount),
          protocolNo: Number(this.createForm.value.protocolNo),
          ambulanceCount: Number(this.createForm.value.ambulanceCount),
        })
        .subscribe((res) => {
          this.appMessageService.successToast(
            'Successful!',
            'successful!',
            20000,
            'top-right'
          );
          this.updateOrg.emit(res);
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openVehicleDialog() {
    this.showVehicleDialog = true;
    this.searchTerm = '';
    this.filteredVehicles = [...this.vehicles];
  }

  onlyNumber(event: KeyboardEvent) {
    const charCode = event.key;
    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault();
    }
  }

  formatPhone(event: any) {
    let value = event.target.value.replace(/\D/g, '').slice(0, 10);
    event.target.value = value;
    this.createForm.get('authorizedPhone')?.setValue(value, { emitEvent: false });
  }
}
